import React from 'react'
import { makeStyles } from 'tss-react/mui'

export const useStyles = makeStyles()((theme) => {
  return {
    banner: {
      alignItems: 'center',
      background: theme.palette.primary.light,
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      padding: theme.spacing(2, 0, 2),
      [theme.breakpoints.up('lg')]: {
        alignItems: 'start',
        padding: theme.spacing(4, 45, 4, 6),
      },
      '& p': {
        fontSize: theme.typography.pxToRem(14),
        [theme.breakpoints.up('sm')]: {
          fontSize: theme.typography.pxToRem(15),
        },
      },
    },
  }
})

interface DocumentLibraryBannerProps {
  currentTab?: string
  children?: React.ReactNode
}

const DocumentLibraryBanner: React.FC<DocumentLibraryBannerProps> = ({
  children,
}) => {
  const { classes } = useStyles()
  return <div className={classes.banner}>{children}</div>
}

export default DocumentLibraryBanner
